import { render, staticRenderFns } from "./NovasNotificacoes.vue?vue&type=template&id=bc7b87d0"
import script from "./NovasNotificacoes.vue?vue&type=script&lang=js"
export * from "./NovasNotificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports